<template>
  <div class="donutChart" :style="{ backgroundImage: this.calculatedBackgroundImage }">
    <div class="donutChart__rating" :class="{ 'no_data' : rating === 0 }">{{ rating > 0 ? rating.toFixed(1) : 'データなし' }}</div>
  </div>
</template>

<script>
export default {
    props: {
        rating: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    computed: {
        calculatedBackgroundImage() {
            const percentage = (this.rating / 5) * 100;
            return `conic-gradient(#F0651A 0deg ${percentage}%, #D9D9D9 ${percentage}% 0deg)`;
        }
    },
}
</script>
